import {
  CLEAR_SIDE_PANEL,
  CLEAR_ERROR,
  DISABLE_SIDE_PANEL_LOADING,
  RESET_PATIENT_VISIT_REMARKS_UPDATED,
} from './PatientSidePanelConstants'
import { SET_ERROR } from '../waitingRoom/WaitingRoomConstants'

export const clearError = () => ({
  type: CLEAR_ERROR,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setError = (error) => ({
  type: SET_ERROR,
  payload: { ErrorCode: error },
})

export const disableSidePanelLoading = () => {
  const action = {
    type: DISABLE_SIDE_PANEL_LOADING,
  }
  return action
}

export const resetRemarksUpdated = () => ({
  type: RESET_PATIENT_VISIT_REMARKS_UPDATED,
})

export const clearSidePanel = () => {
  const action = {
    type: CLEAR_SIDE_PANEL,
  }
  return action
}
